import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import {
  ElasticExpedientesByKeyword, ExpedienteFiltroDTO, Expedientes, ExportExpedientes,
  InventoryIdenty, IResultadoDocument, TIPO_DOCUMENTAL, ResponseAddRelacionContenidoUnidadDocumental, TypeShoppingCart, ShoppingCart
} from '../../core/model/inventories';
import { Page } from '../../core/model/page';
import { ResizedEvent } from '../../core/model/resized-event';
import { AuthenticationService } from '../../core/services/authentication.service';
import { InventariosService } from '../../core/services/inventarios.service';
import { SessionService } from '../../core/services/session.service';
import { ShoppingElementsService } from '../../core/services/shopping-elements.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';
import { ModalShowTextComponent } from '../../utils/modal-show-text/modal-show-text.component';
import { ServiceConfigService } from '../../core/services/service-config.service';
import { Config } from '../../core/model/service-config';


@Component({
  selector: 'app-inventory-viewer',
  templateUrl: './inventory-viewer.component.html',
  styleUrls: ['./inventory-viewer.component.css']
})
export class InventoryViewerComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('tableRecords') table: any;

  @Input() expedientes: IResultadoDocument<Expedientes>[];
  @Input() loading: boolean;
  @Input() page: Page;
  @Input() keyword: ElasticExpedientesByKeyword;
  @Input() advancedSearchFilter: ExpedienteFiltroDTO;
  @Input() isInventoryView = true;
  @Input() showProcessButton = false;
  @Input() clientId = this.sessionService.getClientId();
  @Input() inventoryLevel: number;

  @Output() tableHasBeenRender = new EventEmitter<boolean>();
  @Output() pageChange = new EventEmitter<Page>();
  @Output() setPage = new EventEmitter();

  obsPartial: string;
  isModalEdit = false;
  private idExpedienteSelected: string;

  hasRedirection = true;

  tipoExpediente = TIPO_DOCUMENTAL.expediente;
  tipoContenedor = TIPO_DOCUMENTAL.contenedor;
  tipoAz = TIPO_DOCUMENTAL.az;

  creatingFile = false;


  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  };

  serviceConfig: Config;

  constructor(
    private inventoryService: InventariosService,
    private shoppingElementsService: ShoppingElementsService,
    private router: Router,
    public authService: AuthenticationService,
    private modalService: BsModalService,
    private utilitiesService: UtilitiesService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private sessionService: SessionService,
    private configService: ServiceConfigService
  ) {
    this.serviceConfig = configService.getServiceConfig();
   }

  ngOnInit() {
  }

  ngOnDestroy() {
    // this.inventoryService.restartConsultas();
  }

  ngAfterViewInit() {
    this.tableHasBeenRender.emit(true);
  }

  onResizedRecords(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        if (this.table) {
          this.table.recalculate();
        }
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  goRecordDetail(event) {
    this.inventoryService.notUnload = true;
    if (event.type == 'click' && this.hasRedirection) {
      if ((<InventoryIdenty>event.row).tipoDocumental === TIPO_DOCUMENTAL.expediente) {
        this.inventoryService.goToRecordDetail(event.row, this.keyword, this.expedientes);
      } else if ((<InventoryIdenty>event.row).tipoDocumental === TIPO_DOCUMENTAL.contenedor) {
        this.inventoryService.goToContainers(event.row.id);
      } else {
        this.inventoryService.goToAz(event.row.id);
      }
    }
    if (event.type !== 'activate') {
      this.hasRedirection = true;
     }
  }

  changePage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.pageChange.emit(this.page);
    this.setPage.emit();
  }

  openObsPartialModal(expediente: IResultadoDocument<Expedientes>) {
    this.hasRedirection = false;
    this.idExpedienteSelected = expediente.id;
    this.showModalText();
  }

  closeModal() {
    this.idExpedienteSelected = undefined;
    this.obsPartial = undefined;
    this.isModalEdit = false;
  }

  createPartialLoan() {
    let expedienteSelected: InventoryIdenty = this.expedientes.find(expediente => expediente.id == this.idExpedienteSelected);
    if (this.inventoryService.isCalledFromConsultas()) {
      this.callAddConsultaContenido(expedienteSelected, true, this.obsPartial);
    } else {
      expedienteSelected = this.shoppingElementsService.addOrReplacePartialLoanElement(expedienteSelected, this.obsPartial);
    }
    this.closeModal();
  }

  permitirInsercciones(): boolean {
    return !this.inventoryService.isCalledFromConsultas();
  }

  public isCalledFromConsultas(): boolean {
    return this.inventoryService.isCalledFromConsultas();
  }

  public returnToSolicitud() {
    this.inventoryService.returnToSolicitud();
  }

  editObsPartial(row: IResultadoDocument<Expedientes>) {
    this.hasRedirection = false;
    this.idExpedienteSelected = row.id;
    this.obsPartial = row.shoppingCart.obsPartial;
    this.isModalEdit = true;
    this.showModalText();
  }

  callAddConsultaContenido(record: InventoryIdenty, isParcial: boolean, textParcial: string = null) {
    this.loading = true;
    this.inventoryService.addDocumentoConsulta(record, isParcial, textParcial)
      .subscribe(
        (r: ResponseAddRelacionContenidoUnidadDocumental) => {
          if (!r.isOk) {
            this.toastr.error(this.translateService.instant('consultas.consultaddnook'));
          } else {
            this.toastr.success(this.translateService.instant('consultas.consultaok'));
            const cartShop = new ShoppingCart();
            cartShop.obsPartial = textParcial;
            cartShop.type = isParcial ? TypeShoppingCart.PARTIAL_LOAN : TypeShoppingCart.LOAN;
            record.shoppingCart = cartShop;
            // 🐱‍👤 Despues de consultarlo con Esther, no vuelvo a la solicitud una vez encontrado el expediente a consultar físicamente
            // si luego dicen que vuelva a la solicitud, descomentar la siguiente linea
            // this.returnToSolicitud();
          }
        },
        () => {
          this.loading = false;
          this.toastr.error(this.translateService.instant('consultas.errorconsulta'));
        },
        () => this.loading = false
      );
  }

  createLoan(record: InventoryIdenty) {
    this.hasRedirection = false;
    if (this.inventoryService.isCalledFromConsultas()) {
      this.callAddConsultaContenido(record, false);
    } else {
      record = this.shoppingElementsService.addOrReplaceLoanElement(record);
    }
  }

  createInsertion(record: InventoryIdenty) {
    this.hasRedirection = false;
    record = this.shoppingElementsService.addOrReplaceInsertionElement(record);
  }

  removeRow(row) {
    this.hasRedirection = false;
    const isRemove = this.shoppingElementsService.removeElement(row);

    if (isRemove) {
      row.shoppingCart = null;
    }
  }

  tramitarPedido() {
    this.shoppingElementsService.putElementsToLoan({ clientId: this.clientId, identidades: this.expedientes });

    this.router.navigate(['docout', { outlets: { contenido: 'servicio/prestamosInventario' } }]);
  }

  private showModalText() {
    const modalTitle = !this.isModalEdit ? 'inventory.tittleObsPartial' : 'inventory.tittleEditObsPartial';
    const modalTextConfirm = !this.isModalEdit ? 'inventory.createPartialLoan' : 'inventory.editPartialLoanButton';
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      this.obsPartial,
      modalTextConfirm
    );
    (<ModalShowTextComponent>modal.content).onClose.subscribe((result: string) => {
      if (result && result != '') {
        this.obsPartial = result;
        this.createPartialLoan();
      }
      this.closeModal();
    });
  }

  isContenedor(tipoDocumental: TIPO_DOCUMENTAL) {
    return tipoDocumental == TIPO_DOCUMENTAL.contenedor;
  }

  exportAllRecords() {
    this.creatingFile = true;
    const search = new ExportExpedientes();
    if (!this.keyword) {
      search.AdvancedSearchFilter = this.advancedSearchFilter;
    } else {
      search.KeywordSearchFilter = this.keyword;
    }

    this.inventoryService.getExportFileByKeyword(search)
      .subscribe(result => {
        this.creatingFile = false;
        if (result.type == 'text/plain') {
          this.toastr.info(this.translateService.instant('generales.manyRecords'));
          return;
        }
        const filename = !!this.keyword ? this.keyword.PALABRAS_CLAVE.join('_').substr(0, 25)
          : '_busqueda_avanzada';
        this.utilitiesService.downloadGenericFile('Exportacion' + filename + '.xlsx', result);
      }, error => {
        this.creatingFile = false;
      });
  }
}
